<template>
  <div>
    <div v-for="(service, index) in services" :key="index">
      <div class="p-d-flex p-col-12 line-content line-of-service p-mb-2">
        <div class="text-vertical-center">
          {{service.amount}} - {{service.typeService.name}}
        </div>
        <div class="p-ml-auto text-vertical-center small" style="min-width: fit-content;">
          {{$n(service.price, 'currency')}}
          <a v-if="loggedUser.typeUser !== limited" class="cursor-pointer" @click.prevent="editService(service, index)"><i class="p-ml-2 pi pi-pencil small" :title="$t('protocol.tab-services.edit-service')"/></a>
          <a v-if="loggedUser.typeUser !== limited" class="cursor-pointer" @click.prevent="removeService(service, index)"><i class="p-ml-2 pi pi-times small" :title="$t('protocol.tab-services.remove-service')"/></a>
        </div>
      </div>
    </div>
    <div class="p-col-12 line-content line-of-service p-mb-2 text-center" v-if="services.length === 0">
      {{$t('protocol.tab-services.no-services')}}
    </div>

  </div>
</template>

<script>
import ProtocolBusiness from "@/business/ProtocolBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import EventBus from "@/commons/EventBus";
import CardFormService from "@/viewer/protocol/tabs/services/CardFormService";
import DialogService from "@/business/ModalBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
import store from "@/store";
import {LIMITED} from "@/constants/TypeUser";

export default {
  name: "DisplayProtocolService",

  props:{
    protocol:{type: Object, default: () => {}}
  },

  beforeMount() {
    EventBus.$on('OPEN_ADD_SERVICE_PROTOCOL', this.addService);
  },

  beforeDestroy(){
    EventBus.$off('OPEN_ADD_SERVICE_PROTOCOL');
  },

  data(){
    return {
      services: [],
      limited: LIMITED,
      loggedUser: store.getLoggedUser(),
    }
  },

  async mounted() {
    await this.getServicesProtocol();
  },

  watch: {
    services() {
      EventBus.$emit('SERVICES_PROTOCOL_UPDATED');
    }
  },

  methods:{

    async removeService(service, index){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.deleteTypeOfServiceProtocol(this.protocol.id, service.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.services.splice(index, 1);
          ToastMessageBusiness.showSuccess();
        }
      }
    },

    async getServicesProtocol(){
      const servicesProtocol = await ProtocolBusiness.servicesOfProtocol(this.protocol.id);
      this.services.push(...servicesProtocol);
    },

    addService(){
      EventBus.$emit('CHANGE_COMPONENT_EDITOR', {
        currentComponent: CardFormService,
        callBack: (response) => {
          this.services.push(response);
        },
      });
    },

    editService(service, index){
      EventBus.$emit('CHANGE_COMPONENT_EDITOR', {
        currentComponent: CardFormService,
        paramComponent: service,
        callBack: (response) => {
          this.$set(this.services, index, response);
          this.addService();
        },
      });
    }

  }

}
</script>

<style scoped>

  .line-of-service {
    border-radius: 3px;
    margin-left: auto;
    margin-right: auto;
  }

</style>